import { render, staticRenderFns } from "./ClientsPortfolios.vue?vue&type=template&id=3b67a444"
import script from "./ClientsPortfolios.vue?vue&type=script&lang=js"
export * from "./ClientsPortfolios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports